export default (function (_ref) {
  var request = _ref.request;
  return {
    logisticHongdeWaybillLogQueryJoinUser: function logisticHongdeWaybillLogQueryJoinUser(data) {
      return request({
        url: '/logistics_hongde/waybillLog/queryJoinUser',
        method: 'get',
        params: data
      });
    },
    logisticHongdeWaybillLogDetail: function logisticHongdeWaybillLogDetail(id) {
      return request({
        url: "/logistics_hongde/waybillLog/".concat(id),
        method: 'get'
      });
    }
  };
});